import { getCurrentServerPeople } from '../state';
import { statusBadge } from '../components/status-badge';
import { iconDownload, iconChevronUp, iconChevronDown } from '../icons';

function esc(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}

type SortKey = 'name' | 'role' | 'email' | 'phone' | 'status';
let sortKey: SortKey = 'name';
let sortAsc = true;

function sortPeople(people: typeof import('../state').state.people): typeof import('../state').state.people {
  return [...people].sort((a, b) => {
    const va = a[sortKey];
    const vb = b[sortKey];
    const cmp = String(va).localeCompare(String(vb));
    return sortAsc ? cmp : -cmp;
  });
}

function headerCell(key: SortKey, label: string): string {
  const isActive = sortKey === key;
  const arrowIcon = isActive ? (sortAsc ? iconChevronUp() : iconChevronDown()) : '';
  const activeClass = isActive ? 'th-sorted' : '';
  return `<th data-sort="${key}" class="${activeClass}"><span class="th-content">${esc(label)}<span class="th-arrow">${arrowIcon}</span></span></th>`;
}

export function renderDirectory(body: HTMLElement): void {
  const people = getCurrentServerPeople();
  const sorted = sortPeople(people);
  const reload = (): void => renderDirectory(body);

  const rows = sorted.map(p => `
    <tr>
      <td>${esc(p.name)}</td>
      <td>${esc(p.role)}</td>
      <td>${esc(p.email)}</td>
      <td>${esc(p.phone)}</td>
      <td>${statusBadge(p.status)}</td>
    </tr>`
  ).join('');

  body.innerHTML = `
    <div class="channel-header">
      <h1>Directory</h1>
      <div class="channel-actions">
        <a class="btn btn-secondary" href="/api/directory/export" target="_blank">${iconDownload()} CSV Export</a>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table">
        <thead><tr>
          ${headerCell('name', 'Name')}
          ${headerCell('role', 'Role')}
          ${headerCell('email', 'Email')}
          ${headerCell('phone', 'Phone')}
          ${headerCell('status', 'Status')}
        </tr></thead>
        <tbody>
          ${rows || '<tr><td colspan="5" class="empty-state">No people in directory</td></tr>'}
        </tbody>
      </table>
    </div>`;

  body.querySelectorAll<HTMLTableCellElement>('[data-sort]').forEach(th => {
    th.addEventListener('click', () => {
      const key = th.dataset['sort'] as SortKey;
      if (sortKey === key) { sortAsc = !sortAsc; } else { sortKey = key; sortAsc = true; }
      reload();
    });
  });
}
